/*
 * Copyright (c) 2018 Helvia Technologies PC <contact@helvia.io>
 */

import Icon from '@ant-design/icons';

const FinnishFlagIconSvg = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1.1em" height="1.1em" id="flag-icons-fi" viewBox="0 0 640 480">
    <path fill="#fff" d="M0 0h640v480H0z"/>
    <path fill="#002f6c" d="M0 174.5h640v131H0z"/>
    <path fill="#002f6c" d="M175.5 0h130.9v480h-131z"/>
  </svg>
);

export const FinnishFlagIcon = (props) => (
  <Icon component={FinnishFlagIconSvg} {...props} />
);
